export default function sortBy(array, key) {
  // eslint-disable-next-line no-nested-ternary
  return array.sort((a, b) => (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0));
}
